var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9274 31.0871L54.8951 25.0549L48.0043 0.0151863L45.8944 37.9823L48.0043 95.9728L54.8951 50.9096L60.9274 44.8774L85.9822 37.9823L60.9274 31.0871Z",
    fill: "#E8A44D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0L41.1049 25.0549L35.0726 31.0871L10.0178 37.9823L35.0726 44.8774L41.1049 50.9096L48 96L48.0043 95.9728V0.0151875L48 0Z",
    fill: "#FFCB61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37.9823L41.1049 50.9096L27.1311 58.8512L35.0726 44.8774L48 37.9823Z",
    fill: "#FFDB92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8689 17.1133L60.9274 31.0871L48 37.9823L54.8951 25.0549L68.8689 17.1133Z",
    fill: "#FFCB61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9274 44.8774L68.8689 58.8512L54.8951 50.9096L48 37.9823L60.9274 44.8774Z",
    fill: "#FFDB92"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1049 25.0549L48 37.9823L35.0726 31.0871L27.1311 17.1133L41.1049 25.0549Z",
    fill: "#FFEBC2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.312eee35.svg";
export { ForwardRef as ReactComponent };